export type RunWatch = {
  /** Сообщение ушло, живой processing этого хода ещё не видели. */
  awaitingClaim: boolean
  /** started_at прогона, который забрали через claim. Терминальный снимок должен совпасть. */
  startedAt: string | null
}

export type RunSnapshot = {
  status?: string | null
  started_at?: string | null
}

export function awaitingClaimWatch(): RunWatch {
  return { awaitingClaim: true, startedAt: null }
}

export function isRunActive(status: string | null | undefined): boolean {
  return status === "processing" || status === "cancel_requested"
}

/**
 * Терминальный снимок прошлого прогона приходит параллельно с POST /chat и
 * сжигает одноразовые last_events. Пока ждём claim — любой idle/failed чужой.
 * После processing принимаем только снимок с тем же started_at.
 * watch == null — панель не в отправке, снимок применяется как раньше.
 */
export function classifyRunSnapshot(watch: RunWatch | null, run: RunSnapshot | null | undefined): "apply" | "ignore" {
  if (!watch || (!watch.awaitingClaim && watch.startedAt == null)) return "apply"
  if (isRunActive(run?.status)) return "apply"
  if (watch.awaitingClaim) return "ignore"
  if (watch.startedAt && run?.started_at !== watch.startedAt) return "ignore"
  return "apply"
}

export function watchAfterActiveRun(watch: RunWatch, startedAt: string | null | undefined): RunWatch {
  return { awaitingClaim: false, startedAt: startedAt ?? watch.startedAt }
}
